import { render } from "./ReturnData.vue?vue&type=template&id=55f7a8cd&scoped=true"
import script from "./ReturnData.vue?vue&type=script&lang=js"
export * from "./ReturnData.vue?vue&type=script&lang=js"

import "./ReturnData.vue?vue&type=style&index=0&id=55f7a8cd&scoped=true&lang=css"
import "./ReturnData.vue?vue&type=style&index=1&id=55f7a8cd&lang=less&scoped=true"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f7a8cd"]])

export default __exports__